import http, { getToken, TOKEN_NAME } from "@/services";

export async function loginRequest(registration, password) {
  const { data } = await http.post("/auth/login", {
    registration,
    password,
  });

  return data.token;
}

export async function meRequest() {
  const { data } = await http.get("/auth/me", {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });

  return data;
}

export async function logoutRequest() {
  await http.post(
    "/auth/logout",
    {},
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    },
  );
}

export async function recoveryPasswordRequest(email) {
  await http.post("/auth/recovery-password", {
    email,
    origin: window.location.origin,
  });
}

export async function resetPasswordRequest(token, password) {
  await http.post("/auth/reset-password", { token, password });
}

export async function getImageRequest() {
  const { data } = await http.get("/get-image");

  return data.ieducar_image;
}

export function persistToken(token) {
  localStorage.setItem(TOKEN_NAME, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_NAME);
}
